import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'tariffs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
